import React, { useState, useEffect } from "react";

const ReportIdView = (props) => {
  const [payrollReportID, updatePayrollReportID] = useState("");
  const [coordinatorReportID, updateCoordinatorReportID] = useState("");
  const [editForm, setEditForm] = useState(true);

  const save = async () => {
    const payload = {
      payrollReportID,
      coordinatorReportID,
      clientID: props.companyId
    }
    await props.onSave(payload)
    setEditForm(!editForm)
  }
  useEffect(() => {
    updateCoordinatorReportID(props.coordinatorReportID);
    updatePayrollReportID(props.payrollReportID);
  }, [props.coordinatorReportID, props.payrollReportID]);

  const EditReportId = () => {
    setEditForm(!editForm)
  }

  return (
    <>
      {editForm ? (

        <div className="reportId df align-items-center justify-content-between">
          <div className="reportIdField repordIDCS_wd">
            <p className="repordIDCSs">
              <input type="text" placeholder="Payroll Report ID" readonly="readonly" value={payrollReportID} />
            </p>
          </div>
          <div className="reportIdField repordIDCS_wd">
            <p className="repordIDCSs">
              <input type="text" placeholder="Coordinator Report ID" readonly="readonly" value={coordinatorReportID} />
            </p>
          </div>
          <div className="reportIdField">
            <button className="btn reportBtn" onClick={EditReportId}  >Edit</button>
          </div>
        </div>

      ) : (
        <div className="reportId df align-items-center justify-content-between">
          <div className="reportIdField repordIDCS_wd">
            <input type="text" placeholder="Payroll Report ID" value={payrollReportID} onChange={e => updatePayrollReportID(e.target.value)} />
          </div>
          <div className="reportIdField repordIDCS_wd">
            <input type="text" placeholder="Coordinator Report ID" value={coordinatorReportID} onChange={e => updateCoordinatorReportID(e.target.value)} />
          </div>
          <div className="reportIdField">
            <button className="btn reportBtn" onClick={save} disabled={!payrollReportID || !coordinatorReportID} >Save</button>
          </div>
        </div>

      )}

    </>
  );
};
export default ReportIdView;

